var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab-title"},[_vm._v("全部分类")]),_c('div',{staticClass:"tab-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"tab-item",on:{"click":function($event){return _vm.onList(item)}}},[_vm._v(_vm._s(item.text))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }